'use client';

/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Lib dependencies
import { useAuth0 } from '@auth0/auth0-react';
import { useTranslation } from 'react-i18next';

// UI lib components
import { AppShell, Box, Button, Center, Flex } from '@mantine/core';
import { Outlet } from 'react-router-dom';

// Style
import * as classes from './styles/index.css';

// API & types
import { Suspense, type PropsWithChildren } from 'react';
import { useGetMeQuery } from '@app-types/blackroom-api';

// View-as
import { setViewAsUser } from '@app/shared/providers/ViewAsProvider/store';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */

function GateLayout({ children, ...props }: PropsWithChildren) {
  /* ********************************** HOOKS ********************************* */

  // Auth
  const { user, logout } = useAuth0();

  // API
  const { data: meData } = useGetMeQuery();

  // Localization
  const { t } = useTranslation('Account');

  /* ******************************** RENDERING ******************************* */

  return (
    <Box className={classes.gateLayout}>
      <AppShell>
        <AppShell.Header bg="transparent" withBorder={false}>
          {user && meData?.me ? (
            <Flex p="xl" justify="end" w="100%">
              <Button
                radius="xs"
                variant="subtle"
                onClick={() => {
                  setViewAsUser(null);
                  logout({
                    logoutParams: { returnTo: window.location.origin },
                  });
                }}
              >
                {' '}
                {t('AccountMenu.logoutCta')}
              </Button>
            </Flex>
          ) : null}
        </AppShell.Header>
        <AppShell.Main>
          <Center h="100%" w="100%" style={{ alignItems: 'center' }}>
            <Box maw="30%">
              <Suspense>
                <Outlet />
              </Suspense>
            </Box>
          </Center>
        </AppShell.Main>
      </AppShell>
    </Box>
  );
}

export default GateLayout;
